import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import $ from "jquery";

const UserEmailList = ({ emailListObj }) => {
  const { userToken, SetSharedObject } = useUserStore((state) => ({
    userToken: state.userToken,
    SetSharedObject: state.SetSharedObject,
  }));
  const [userObj, setUserObj] = useState([]);
  const [emlPurpose, setEmlPurpose] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [noReply, setNoReply] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const [time, setTime] = useState(Date.now());
  const [newPurposeId, SetNewPurposeId] = useState("");
  const [newEmail, SetNewEmail] = useState("");
  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [errMsg, SetErrMsg] = useState(false);
  const [errEmail, SetErrEmail] = useState(false);
  const navigate = useNavigate();
  let tempObj = [];

  useEffect(() => {
    setSuccessMsg(false);
    SetErrMsg("");
    SetErrCreateMsg(false);
    setProcessing(false);
    SetNewPurposeId(0);
    return () => {
      SetNewEmail("");
      SetNewPurposeId(0);
      setNoReply(false);
      SetErrEmail(false);
    };
  }, [emailListObj, time]);

  const containsSpacesOrSpecialChars = (str) => {
    let flag = /[^a-zA-Z0-9-_@.]/.test(str);
    return flag;
  };
  const AddEmail = async () => {
    setSuccessMsg(false);
    SetErrEmail(false);
    SetErrMsg("");
    SetErrCreateMsg(false);
    if (newEmail === "" || newPurposeId === "") {
      SetErrMsg("Email Name and purpose of this email are required.");
      SetErrCreateMsg(true);
      return;
    } else if (
      newEmail !== "" &&
      (containsSpacesOrSpecialChars(newEmail) || newEmail < 4)
    ) {
      document.getElementById("ContactEmail").scrollIntoView();
      document.getElementById("ContactEmail").focus();
      SetErrEmail(true);
      return;
    }
    setProcessing(true);
    let call =
      "/users/AddUserDirectEmail?userId=" +
      emailListObj.id +
      "&newDirectEmail=" +
      newEmail +
      "&purposeId=" +
      newPurposeId +
      "&domainName=" +
      emailListObj.domainName +
      "&noReply=" +
      noReply;
    const res = await CallAPI(call, null, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    setProcessing(false);
    if (res.status === "SUCCESS") {
      let obj = res.data.data;
      if (emailListObj.Flag) SetSharedObject("reloadEmailList", true);
      setSuccessMsg(true);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      if (
        Array.isArray(msg) ||
        (Object.keys(msg).length > 0 && msg.constructor === Object)
      ) {
        let str = "<div>";
        for (let el of msg) {
          str += `${el}`;
        }
        str += "</div>";
        SetErrMsg(str);
      } else {
        if (msg.includes("Email address already exists")) {
          SetErrMsg(
            "Email already exists. Please try again with a different name."
          );
        } else {
          SetErrMsg(
            "System encoountered an error. Please try again. If the problem persists, please contact your administrator."
          );
        }
      }

      SetErrCreateMsg(true);
      setProcessing(false);
    }
  };
  return (
    <>
      <div
        className="modal fade"
        id="UsrEmailList"
        data-backdrop="static"
        data-keyboard="false"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="User Delete Confirmation"
        aria-hidden="false"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title">Add Direct Email</div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="false">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="modal-content-form">
                <div className="field-wrapper">
                  <label>Account:</label>
                  <span className="text-size6">
                    {emailListObj?.firstName} {emailListObj?.lastName}
                  </span>
                </div>
                <div className="field-wrapper">
                  <label for="forgotUser">Email Name</label>
                  <div className="input-group mb-3">
                    <input
                      type="text"
                      className="form-control field-direct"
                      aria-label="Enter new email name"
                      aria-describedby="basic-addon2"
                      value={newEmail}
                      id="ContactEmail"
                      onChange={(el) => {
                        SetErrCreateMsg(false);
                        setSuccessMsg(false);
                        SetNewEmail(el.target.value);
                      }}
                    />
                    <div className="input-group-append">
                      <span
                        className="input-group-text field-direct-addon"
                        id="basic-addon2"
                      >
                        &#64;{emailListObj?.domainName}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="field-wrapper w-set1">
                  <label for="forgotUser">
                    What is the purpose of this email?
                  </label>
                  <div className="email-purpose-wrapper">
                    <select
                      className="form-control"
                      name="EmailPurpose"
                      value={newPurposeId}
                      onChange={(el) => SetNewPurposeId(el.target.value)}
                    >
                      <option value="0">General</option>
                      <option value="1">Medical Records XML only</option>
                      <option value="2">Medical Records</option>
                      <option value="3">Administrative</option>
                    </select>
                  </div>
                </div>
                {/*<div className="field-wrapper">*/}
                {/*  <div className="NoReply spacer-inline">*/}
                {/*    <input*/}
                {/*      className="form-control spacer-margin5 sp-mx"*/}
                {/*      type="checkbox"*/}
                {/*      value={noReply}*/}
                {/*      checked={noReply}*/}
                {/*      onChange={(el) => setNoReply(el.target.checked)}*/}
                {/*    />*/}
                {/*  </div>*/}
                {/*  <label className="v-top">Set as no-reply mailbox</label>*/}
                {/*  <aside className="sp-margin13 line-s1">*/}
                {/*    Check this box if this mailbox cannot reply to emails.*/}
                {/*  </aside>*/}
                {/*</div>*/}
                {errCreateMsg ? (
                  <div
                    className={`alert alert-danger`}
                    dangerouslySetInnerHTML={{ __html: errMsg }}
                  />
                ) : null}
                {successMsg ? (
                  <div className="alert alert-success" role="alert">
                    Direct email has been added successfully to{" "}
                    {emailListObj.accountName}.
                  </div>
                ) : null}
                {errEmail ? (
                  <div className="alert alert-danger">
                    Please enter a valid email name with no spaces, commas, or
                    special characters.
                  </div>
                ) : null}
              </div>
            </div>
            <div className="modal-footer">
              {processing ? <div className="loading"></div> : null}

              <button
                type="button"
                className="btn btn-success"
                onClick={(e) => AddEmail()}
              >
                Add Email
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-dismiss="modal"
              >
                Cancel
              </button>
            </div>
            {/*{processing ? <div className="loading"></div> : null}*/}
          </div>
        </div>
      </div>
    </>
  );
};
export default UserEmailList;
